import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
} from 'formik'
import {
  FormControl,
  FormControlLabel,
  Typography,
  TextField,
} from '@material-ui/core'

import SpinnerSubmitButton from '../controls/buttons/SpinnerSubmitButton'
import InputValidationTooltip from '../controls/input/InputValidationTooltip'

import SmallArrowRight from '../../../assets/images/icons/ico_arrow_small.svg'

class EmailView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  static styles = (theme) => ({
    formControl: {
      width: '100%',
      margin: theme.spacing(4, 0),
    },
    labelRoot: theme.formControlLabelRoot,
    label: theme.label,
    textFieldRoot: theme.loginTextFieldRoot,
  })

  validateForm = (values) => {
    const errors = {}

    if (!values.email.trim()) {
      errors.email = 'Email required'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid email address'
    }

    return errors
  }


  handleNext = (values) => {
    this.props.onSubmit(values.email)
  }

  render() {
    const { classes } = this.props

    return (
      <Formik
        initialValues={{
          email: '',
        }}
        validate={this.validateForm}
        onSubmit={this.handleNext}
      >
        {(formikProps) => (
          <Form>
            <Typography variant="h1">Welcome to BlokSense</Typography>
            <Typography variant="h2">Sign in to your Insights Dashboard</Typography>

            <Field
              name="email"
              value={formikProps.values.email}
              onChange={formikProps.handleChange}
              onBlur={formikProps.handleBlur}
            >
              {({ field, form: { touched, errors } }) => (
                <FormControl className={classes.formControl}>
                  <FormControlLabel
                    classes={{ root: classes.labelRoot, label: classes.label }}
                    label="Email"
                    labelPlacement="top"
                    control={(
                      <TextField
                        {...field}
                        autoComplete="on"
                        classes={{ root: classes.textFieldRoot }}
                        error={touched.email && Boolean(errors.email)}
                        fullWidth
                        placeholder="Email"
                        variant="outlined"
                        type="email"
                      />
                    )}
                  />
                  <ErrorMessage name="email">
                    { (msg) => <InputValidationTooltip title={msg} /> }
                  </ErrorMessage>
                </FormControl>
              )}
            </Field>

            <SpinnerSubmitButton
              onClick={formikProps.handleSubmit}
              isSubmitting={formikProps.isSubmitting}
            >
              Next
              <img src={SmallArrowRight} alt="→" />
            </SpinnerSubmitButton>
          </Form>
        )}
      </Formik>
    )
  }
}

export default withStyles(EmailView.styles)(EmailView)
